/**
 * LeisureMod Commercial — homepage scroll-reveal
 *
 * Safety pattern: adds "js-reveal-ready" to <html> ONLY once we've
 * confirmed IntersectionObserver works and elements exist to observe.
 * The CSS only hides ".lm-reveal" content when that class is present —
 * so if this script errors, loads late, or gets blocked for any reason,
 * content simply stays visible at its natural state instead of being
 * stuck invisible. This is a deliberate fix for exactly that failure
 * mode, not just an animation nicety.
 *
 * Toggles ".lm-reveal--visible" on elements with the ".lm-reveal" class
 * whenever they scroll into view — and removes it when they scroll back
 * out, so the animation replays whether scrolling down into a section or
 * back up into it from below. Purely additive: does not touch any
 * existing theme/app JavaScript, element IDs, or interactive behavior
 * (e.g. the Before/After slider's own drag logic is untouched).
 */
(function () {
	if (!("IntersectionObserver" in window)) return;

	var elements = document.querySelectorAll(".lm-reveal");
	if (!elements.length) return;

	document.documentElement.classList.add("js-reveal-ready");

	var observer = new IntersectionObserver(
		function (entries) {
			entries.forEach(function (entry) {
				entry.target.classList.toggle("lm-reveal--visible", entry.isIntersecting);
			});
		},
		{ threshold: 0.15, rootMargin: "0px 0px -80px 0px" }
	);

	elements.forEach(function (el) {
		observer.observe(el);
	});
})();